import styled from 'styled-components'
import call from '../Assets/call.svg'
import whatsapp from '../Assets/whatsapp.svg'
import avatar from '../Assets/pulse_avatar.svg'
import profileBg from '../Assets/profile_bg.png'
import { useAuthContext } from './contexts/AuthContext'
import { Grid } from '@material-ui/core'
import { Fragment } from 'react'

function Profile() {
    const { userDetails } = useAuthContext()

    return (
        <ProfileWrapper>
            <ProfileBgSection>
                <ProfileBG>
                    <img src={profileBg} alt="profile_bg" />
                </ProfileBG>
                <Heading>My Profile</Heading>
            </ProfileBgSection>
            <ProfileImage>
                <img
                    src={!!userDetails?.image ? userDetails?.image : avatar}
                    alt="profile"
                />
            </ProfileImage>
            <ProfileMainContent>
                <Name>{userDetails?.name}</Name>
            </ProfileMainContent>

            <ProfileCard>
                <Profile3inROw>
                    {[
                        {
                            text: 'Roll No.',
                            value: userDetails?.rollNo
                        },
                        {
                            text: 'Batch',
                            value: userDetails?.batch?.batchName
                        },
                        {
                            text: `DOB`,
                            value: userDetails?.DOB
                        }
                    ].map((el, key) => (
                        <Label key={key}>
                            <p>{el.text}</p>
                            <span>{el.value}</span>
                        </Label>
                    ))}
                </Profile3inROw>

                <Grid container spacing={2}>
                    {[
                        {
                            text: 'Stream',
                            value: userDetails?.stream
                        },
                        {
                            text: 'Gender',
                            value: userDetails?.gender
                        },
                        {
                            text: `Father's Name`,
                            value: userDetails?.father
                        },
                        {
                            text: `Mother's Name`,
                            value: userDetails?.mother
                        },
                        {
                            text: `Address`,
                            value: userDetails?.address
                        }
                    ].map((item, key) => (
                        <Fragment key={key}>
                            <Grid item xs={5}>
                                <DetailLabel>{item.text}</DetailLabel>
                            </Grid>
                            <Grid item xs={1}>
                                {`:`}
                            </Grid>
                            <Grid item xs={6}>
                                {item.value}
                            </Grid>
                        </Fragment>
                    ))}
                </Grid>

                <ContactSection>
                    <Grid container spacing={3}>
                        <Grid item xs={6}>
                            <ContactLabel>
                                <img src={call} alt="call" />
                                <p>{userDetails?.mobile}</p>
                            </ContactLabel>
                        </Grid>
                        <Grid item xs={6}>
                            <ContactLabel>
                                <img src={whatsapp} alt="whatsapp" />
                                <p>{userDetails?.whatsapp}</p>
                            </ContactLabel>
                        </Grid>
                    </Grid>
                </ContactSection>
            </ProfileCard>
        </ProfileWrapper>
    )
}

const ProfileWrapper = styled.div`
    margin-bottom: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
`

const ProfileBgSection = styled.div`
    padding-top: 1rem;
    height: 180px;
    width: 100%;
`
const ProfileBG = styled.div`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    width: 100%;
    z-index: -1;
    height: 180px;
    transform-origin: bottom;
    overflow: hidden;

    img {
        width: 100%;
        height: 100%;
        object-fit: cover;
    }
`

const Heading = styled.h1`
    text-align: center;
    color: #fff;
    margin: 30px 0;
    font-size: 24px;
    z-index: 1;
`

const ProfileImage = styled.div`
    pointer-events: none;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    margin-top: -4rem;
    img {
        width: 8rem;
        height: 8rem;
        border: 3px solid #fff;
        border-radius: 50%;
        object-fit: cover;
    }
`

const ProfileMainContent = styled.div`
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    color: #e6e6eb;
    margin-bottom: 1.5rem;
    font-size: 14px;

    @media (min-width: 768px) {
        font-size: 16px;
    }
`
const Name = styled.p`
    font-weight: 600;
    margin-top: 0.6rem;
    margin-bottom: 6px;
    text-align: center;
    font-size: 16px;

    @media (min-width: 768px) {
        font-size: 20px;
    }
`

const ProfileCard = styled.div`
    padding: 20px;
    background: linear-gradient(
            314.55deg,
            rgba(255, 255, 255, 0.05) 2.86%,
            rgba(255, 255, 255, 0) 93.11%
        ),
        linear-gradient(
            131.63deg,
            rgba(41, 43, 92, 0.6) 9.65%,
            rgba(40, 43, 92, 0.58) 93.77%
        ),
        linear-gradient(
            105.27deg,
            rgba(255, 255, 255, 0.105) 2.25%,
            rgba(154, 154, 154, 0.035) 49.02%,
            rgba(201, 201, 201, 0.07) 60.55%,
            rgba(255, 255, 255, 0.042) 68.44%,
            rgba(129, 143, 161, 0.0424448) 84.06%,
            rgba(0, 28, 65, 0) 100%
        );
    box-shadow: 0px 0px 0px -1px rgba(255, 255, 255, 0.1);
    backdrop-filter: blur(22px);
    border-radius: 15px;
    color: #e6e6eb;
    max-width: 500px;
    margin: auto;
    font-size: 14px;

    @media (min-width: 768px) {
        font-size: 16px;
    }
`

const Profile3inROw = styled.div`
    margin: 0 0 1.3rem 0;
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Label = styled.div`
    p {
        font-weight: 600;
        text-align: center;
    }
    span {
        text-align: center;
        font-weight: 300;
        margin-top: 5px;
        display: block;
    }
`

const DetailLabel = styled.p`
    font-weight: 600;
`

const ContactSection = styled.div`
    margin-top: 1.5rem;
`

const ContactLabel = styled.div`
    display: flex;
    align-items: center;
    padding: 0 5px;
    margin: 10px 0;

    img {
        margin-right: 10px;
    }
    p {
        font-weight: 300;
    }
`

export default Profile
